import type { SVGProps } from 'react'

import type { FileRoutesByFullPath } from '@/routeTree.gen'
import MaterialSymbolsCalendarMonthOutlineRounded from '~icons/material-symbols/calendar-month-outline-rounded'
import MaterialSymbolsCalendarMonthRounded from '~icons/material-symbols/calendar-month-rounded'
import MaterialSymbolsFavoriteOutlineRounded from '~icons/material-symbols/favorite-outline-rounded'
import MaterialSymbolsFavoriteRounded from '~icons/material-symbols/favorite-rounded'
import MaterialSymbolsHomeOutlineRounded from '~icons/material-symbols/home-outline-rounded'
import MaterialSymbolsHomeRounded from '~icons/material-symbols/home-rounded'
import MaterialSymbolsManageAccountsRounded from '~icons/material-symbols/manage-accounts-rounded'
import MaterialSymbolsMonetizationOnOutlineRounded from '~icons/material-symbols/monetization-on-outline-rounded'
import MaterialSymbolsMonetizationOnRounded from '~icons/material-symbols/monetization-on-rounded'
import MaterialSymbolsSettingsOutlineRounded from '~icons/material-symbols/settings-outline-rounded'
import MaterialSymbolsSettingsRounded from '~icons/material-symbols/settings-rounded'
import MaterialSymbolsTableBarOutlineRounded from '~icons/material-symbols/table-bar-outline-rounded'
import MaterialSymbolsTableBarRounded from '~icons/material-symbols/table-bar-rounded'
import MdiAccountGroup from '~icons/mdi/account-group'
import MdiAccountGroupOutline from '~icons/mdi/account-group-outline'
import MdiDice5 from '~icons/mdi/dice-5'
import MdiDice5Outline from '~icons/mdi/dice-5-outline'
import MdiTable from '~icons/mdi/table'

export type NavItem = {
  to: keyof FileRoutesByFullPath
  label: string
  icon: (props: SVGProps<SVGSVGElement>) => React.ReactNode
  iconActive?: (props: SVGProps<SVGSVGElement>) => React.ReactNode
  module?: string
  superAdminOnly?: boolean
}

export const AdminNavItems: NavItem[] = [
  {
    to: '/admin',
    label: 'หน้าแรก',
    icon: MaterialSymbolsHomeOutlineRounded,
    iconActive: MaterialSymbolsHomeRounded,
  },
  {
    to: '/admin/guests/',
    label: 'รายชื่อแขก',
    icon: MdiAccountGroupOutline,
    iconActive: MdiAccountGroup,
    module: 'guests',
  },
  {
    to: '/admin/tables',
    label: 'จัดการโต๊ะ',
    icon: MdiTable,
    iconActive: MdiTable,
    module: 'tables',
  },
  {
    to: '/admin/blessings',
    label: 'คำอวยพร',
    icon: MaterialSymbolsFavoriteOutlineRounded,
    iconActive: MaterialSymbolsFavoriteRounded,
    module: 'blessings',
  },
  {
    to: '/admin/angpao',
    label: 'อั่งเปา',
    icon: MaterialSymbolsMonetizationOnOutlineRounded,
    iconActive: MaterialSymbolsMonetizationOnRounded,
    module: 'angpao',
  },
  {
    to: '/admin/random-number',
    label: 'สุ่มหมายเลข',
    icon: MdiDice5Outline,
    iconActive: MdiDice5,
    module: 'random-number',
  },
  {
    to: '/admin/settings',
    label: 'ตั้งค่า',
    icon: MaterialSymbolsSettingsOutlineRounded,
    iconActive: MaterialSymbolsSettingsRounded,
    module: 'settings',
  },
  {
    to: '/admin/users',
    label: 'ผู้ดูแล',
    icon: MaterialSymbolsManageAccountsRounded,
    iconActive: MaterialSymbolsManageAccountsRounded,
    superAdminOnly: true,
  },
]

export const UserNavItems: NavItem[] = [
  {
    to: '/',
    label: 'หน้าแรก',
    icon: MaterialSymbolsHomeOutlineRounded,
    iconActive: MaterialSymbolsHomeRounded,
  },
  {
    to: '/agenda',
    label: 'กำหนดการ',
    icon: MaterialSymbolsCalendarMonthOutlineRounded,
    iconActive: MaterialSymbolsCalendarMonthRounded,
  },
  {
    to: '/map',
    label: 'ผังโต๊ะ',
    icon: MaterialSymbolsTableBarOutlineRounded,
    iconActive: MaterialSymbolsTableBarRounded,
  },
  {
    to: '/activities/',
    label: 'กิจกรรม',
    icon: MdiDice5Outline,
    iconActive: MdiDice5,
  },
]
